import React from "react";
import { Box, Chip } from "@mui/material";
import logo from '../../assets/images/stream.png';
import EmailSender from "containers/pages/CANmail/components/EmailSender/EmailSender";
import FeatureErrorBoundary from "components/errorBoundary/FeatureErrorBoundary";

function EmailSenderPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "95vh", 
      }}
    >
      {/* Main content area */}
      <Box sx={{ flex: 1, p: { xs: 0, sm: 4 } }}>
        {/* Isolates a composer crash from the rest of the SPA, per
            docs/FRONTEND_ERROR_HANDLING_STANDARDS.MD. */}
        <FeatureErrorBoundary featureName="Email Sender">
          <EmailSender />
        </FeatureErrorBoundary>
      </Box>

      {/* Footer with Chip */}
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <Chip
          label="Powered by Stream Data Systems"
          variant="outlined"
          icon={
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ width: 20, height: 20 }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default EmailSenderPage;
